import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Cómo recibo el programa?',
  answer: 'El programa es 100% digital. Inmediatamente después de tu compra, recibirás un correo electrónico con el enlace de descarga de todos los materiales (Guías PDF, Recetario, Plan de Ejercicios) para que empieces hoy mismo.'
}, {
  question: '¿Necesito ir al gimnasio?',
  answer: 'No. El Protocolo Mínimo Efectivo son solo 12 minutos de ejercicios que puedes hacer en tu sala sin equipamiento especial.'
}, {
  question: '¿Es una dieta restrictiva?',
  answer: 'No. Incluye recetas latinas deliciosas como tacos y pancakes. No contarás calorías ni pasarás hambre, nos enfocamos en la calidad de los nutrientes.'
}, {
  question: '¿Funciona si tengo más de 50 años?',
  answer: 'Sí. El protocolo está diseñado específicamente para la biología de la mujer después de los 40, incluyendo pre y post menopausia, enfocándose en el equilibrio hormonal.'
}, {
  question: '¿Cuándo veré resultados?',
  answer: 'La mayoría de mujeres notan reducción de hinchazón en los primeros 5-7 días (Fase Detox). Resultados visibles en contorno abdominal y energía a los 21 días.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 bg-[#FFF7ED]" data-id="element-48">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-49">
        <div className="text-center mb-12" data-id="element-50">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1F2937] mb-4" data-id="element-51">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-4" data-id="element-52">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-orange-100 overflow-hidden" data-id="element-53">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-54">
                <span className="font-bold text-[#1F2937] text-lg" data-id="element-55">
                  {faq.question}
                </span>
                <ChevronDown className={`text-[#F97316] transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-56" />
              </button>

              <AnimatePresence data-id="element-57">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-58">
                    <div className="px-6 pb-6 text-[#6B7280] leading-relaxed border-t border-gray-50 pt-4" data-id="element-59">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}